'use client';

import React, { useEffect } from 'react';
import { ChakraProvider, Flex, Box, Heading, Text, Icons } from '@shared/ui';
import * as Sentry from '@sentry/nextjs';
import i18n from '@shared/i18n';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <ChakraProvider>
            <Flex h="calc(100vh)" alignItems="center" justifyContent="center">
                <Box w="100%" maxW="365px" mx="auto" py="xl" textAlign="center">
                    <Box display="inline-block" color="negative.030">
                        <Icons.csr.SmileySad size="80px" weight="bold" />
                    </Box>
                    <Box mt="9px">
                        <Heading
                            fontSize={{
                                base: '24px',
                                md: '30px',
                            }}
                            color="neutral.120"
                            lineHeight="1.5"
                        >
                            {i18n.gettext('糟糕，發生不可預期的錯誤')}
                        </Heading>
                    </Box>
                    <Box
                        mt={{
                            base: '24px',
                            md: '32px',
                            lg: '42px',
                        }}
                    >
                        <Text fontSize="16px" color="neutral.080" lineHeight="1.5">
                            {i18n.gettext('載入時發生不明錯誤，請稍後再試一次')}
                        </Text>
                    </Box>
                </Box>
            </Flex>
        </ChakraProvider>
    );
}
